import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Form, FloatingLabel, Alert } from 'react-bootstrap';
import GoBack from '../general/go_back';
import FetchButton from 'components/general/FetchButton';
import { errorToaster, showToaster } from 'mixin/general';
import { changePasswordReq } from 'services/AuthService';
import { AWS_BUCKET_URL } from '../../toolkit/constants';

export default function ChangePassword() {
  const { t } = useTranslation('translations');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    newPasswordRepeat: ''
  });

  const handleFormDataChange = (key, value) => {
    setFormData((oldValue) => ({ ...oldValue, [key]: value }));
  };

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    setValidated(true);
    if (!form.checkValidity()) throw new Error(t('pages.changePassword.errorFillForm'));
    if (formData.newPassword !== formData.newPasswordRepeat)
      throw new Error(t('pages.changePassword.errorUnmatchedPassword'));
  };

  const handleLogin = async (e) => {
    try {
      e.preventDefault();
      handleSubmit(e);
      setIsSubmitting(true);
      const response = await changePasswordReq(formData);
      if (!response) {
        throw new Error('Login error');
      }
      showToaster(t('pages.changePassword.successMessageChangePassword'), 'success');
    } catch (error) {
      errorToaster(error);
    }
    setIsSubmitting(false);
  };
  return (
    <Container>
      <Row className="mt-75 text-start align-items-center">
        <Col xs={1}>
          <GoBack />
        </Col>
        <Col>
          <div className="fw-bold fs-14">{t('myprofile')}</div>
        </Col>
      </Row>
      <hr className="my-75" />
      <Form noValidate validated={validated} onSubmit={handleLogin}>
        <Form.Floating className="mb-3">
          <FloatingLabel
            controlId="oldPassword"
            label={t('pages.changePassword.form.oldPassword.label')}>
            <Form.Control
              type="password"
              value={formData.oldPassword}
              onInput={(event) => handleFormDataChange('oldPassword', event.target.value)}
              placeholder={t('pages.changePassword.form.oldPassword.placeholder')}
              required
            />
          </FloatingLabel>
        </Form.Floating>
        <Form.Floating className="mb-3">
          <FloatingLabel
            controlId="newPassword"
            label={t('pages.changePassword.form.newPassword.label')}>
            <Form.Control
              type="password"
              minLength={8}
              value={formData.newPassword}
              onInput={(event) => handleFormDataChange('newPassword', event.target.value)}
              placeholder={t('pages.changePassword.form.newPassword.placeholder')}
              required
            />
          </FloatingLabel>
        </Form.Floating>
        <Form.Floating className="mb-3">
          <FloatingLabel
            controlId="confirmPassword"
            label={t('pages.changePassword.form.confirmPassword.label')}>
            <Form.Control
              type="password"
              minLength={8}
              value={formData.newPasswordRepeat}
              onInput={(event) => handleFormDataChange('newPasswordRepeat', event.target.value)}
              placeholder={t('pages.changePassword.form.confirmPassword.placeholder')}
              required
            />
          </FloatingLabel>
        </Form.Floating>
        <Alert variant={'secondary'} className="d-flex align-items-center text-start">
          <img width="25" height="25" src={`${AWS_BUCKET_URL}/Icons/133.png`} />
          <span className="ms-2">{t('pages.changePassword.infoPasswordRequirements')}</span>
        </Alert>
        <FetchButton className="w-100" type="submit" variant="success" fetching={isSubmitting}>
          {t('pages.changePassword.form.buttonSubmit')}
        </FetchButton>
      </Form>
    </Container>
  );
}
